// extracted by mini-css-extract-plugin
export default {"descriptionBlock":"ProfileInfo_descriptionBlock__i9jCm","img":"ProfileInfo_img__omLnE","status":"ProfileInfo_status__GEb4+","fileButton":"ProfileInfo_fileButton__80AoX"};